export default __webpack_public_path__ + "static/media/TickIcon.d263b75f.svg";